{
  "title": "Invulnerability",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "9th-level abjuration",
  "level": 9,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a small piece of adamantine worth at least 500 gp, which the spell consumes)",
  "duration": "Concentration, up to 10 minutes",
  "description": ["You are immune to all damage until the spell ends."],
  "spellLists": ["wizard"]
}
